import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '@/analytics/ga';
import { trackRedditPageview } from '@/analytics/reddit';

// Import test functions to make them available globally
import '@/utils/reddit-test';

export const GtagRouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const fullPath = location.pathname + location.search;
    
    // Send page view to Google Analytics on route change
    trackPageview(fullPath);
    
    // Send page view to Reddit Pixel on route change
    trackRedditPageview(fullPath);
  }, [location]);

  return null;
};